module.exports = __webpack_public_path__ + "img/left-logo.5c519537.png";